import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiTripleYpsili';
const args = {};

export class PetastiTripleYpsili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
